import React from 'react';
import { Link } from 'react-router-dom';

export default function DataDeletion() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-primary, #0a0a0f)', color: 'var(--text-primary, #e4e4f0)', padding: '60px 24px' }}>
      <div style={{ maxWidth: 760, margin: '0 auto' }}>

        {/* Header */}
        <div style={{ marginBottom: 48 }}>
          <Link to="/login" style={{ fontFamily: 'monospace', fontSize: 11, color: 'var(--text-dim, #666)', textDecoration: 'none', letterSpacing: '2px' }}>
            ← BACK TO SIGNAL
          </Link>
          <div style={{ fontFamily: 'monospace', fontSize: 10, color: 'var(--text-dim, #666)', letterSpacing: '3px', textTransform: 'uppercase', marginTop: 32, marginBottom: 8 }}>
            Legal
          </div>
          <h1 style={{ fontSize: 32, fontWeight: 600, marginBottom: 8 }}>Data Deletion Request</h1>
          <p style={{ color: 'var(--text-dim, #888)', fontSize: 13 }}>
            How to delete your data from Signal &nbsp;·&nbsp; GoLaunchNow Inc. &nbsp;·&nbsp; golaunchnow.io
          </p>
        </div>

        <style>{`
          .dd-section { margin-bottom: 40px; }
          .dd-section h2 { font-size: 18px; font-weight: 600; margin-bottom: 14px; color: #e4e4f0; }
          .dd-section p, .dd-section li { font-size: 14px; line-height: 1.8; color: #aaa; margin-bottom: 10px; }
          .dd-section ul, .dd-section ol { padding-left: 20px; }
          .dd-section li { margin-bottom: 6px; }
          a { color: #a78bfa; }
          .dd-step-number {
            display: inline-flex; align-items: center; justify-content: center;
            width: 28px; height: 28px; border-radius: 50%;
            background: #a78bfa; color: #0a0a0f; font-weight: 700; font-size: 13px;
            margin-right: 12px; flex-shrink: 0;
          }
          .dd-step {
            display: flex; align-items: flex-start; margin-bottom: 20px;
          }
          .dd-step-content { flex: 1; }
          .dd-step-content strong { color: #e4e4f0; display: block; margin-bottom: 2px; }
          .dd-step-content p { margin-bottom: 0; }
          .dd-info-box {
            background: rgba(167, 139, 250, 0.08);
            border-left: 3px solid #a78bfa;
            padding: 14px 18px; border-radius: 0 8px 8px 0;
            margin-top: 16px; font-size: 13px; color: #c4b5fd; line-height: 1.7;
          }
        `}</style>

        {/* Option 1: Via Facebook */}
        <div className="dd-section">
          <h2>Option 1 — Remove via Facebook</h2>
          <div className="dd-step">
            <span className="dd-step-number">1</span>
            <div className="dd-step-content">
              <strong>Open Facebook Settings</strong>
              <p>Log in to Facebook and go to <em>Settings &amp; Privacy → Settings</em>.</p>
            </div>
          </div>
          <div className="dd-step">
            <span className="dd-step-number">2</span>
            <div className="dd-step-content">
              <strong>Go to Apps and Websites</strong>
              <p>In the left menu, click <em>Apps and Websites</em>.</p>
            </div>
          </div>
          <div className="dd-step">
            <span className="dd-step-number">3</span>
            <div className="dd-step-content">
              <strong>Find Signal</strong>
              <p>Locate <strong style={{ color: '#e4e4f0' }}>Signal</strong> in the list of active apps.</p>
            </div>
          </div>
          <div className="dd-step">
            <span className="dd-step-number">4</span>
            <div className="dd-step-content">
              <strong>Remove the app</strong>
              <p>Click <em>Remove</em> and check the box to <em>Delete all posts, videos, and data</em> that Signal received about you.</p>
            </div>
          </div>
          <div className="dd-info-box">
            Removing the app through Facebook automatically triggers our data deletion process. You do not need to take any additional steps.
          </div>
        </div>

        {/* Option 2: Direct request */}
        <div className="dd-section">
          <h2>Option 2 — Request deletion directly</h2>
          <p>If you prefer, you can contact us directly to request data deletion.</p>
          <div className="dd-step">
            <span className="dd-step-number">1</span>
            <div className="dd-step-content">
              <strong>Send us an email</strong>
              <p>Email <a href="mailto:privacy@golaunchnow.io">privacy@golaunchnow.io</a> with the subject line <em>"Data Deletion Request"</em>.</p>
            </div>
          </div>
          <div className="dd-step">
            <span className="dd-step-number">2</span>
            <div className="dd-step-content">
              <strong>Include your details</strong>
              <p>Provide the email address associated with your account so we can locate your data.</p>
            </div>
          </div>
          <div className="dd-step">
            <span className="dd-step-number">3</span>
            <div className="dd-step-content">
              <strong>Receive confirmation</strong>
              <p>We will process your request and send a confirmation email within <strong style={{ color: '#e4e4f0' }}>30 days</strong>.</p>
            </div>
          </div>
        </div>

        {/* What we delete */}
        <div className="dd-section">
          <h2>What data do we delete?</h2>
          <p>When you submit a deletion request, we remove all personal data associated with your account, including:</p>
          <ul>
            <li><strong style={{ color: '#e4e4f0' }}>Account information:</strong> Your name, email address, and profile information.</li>
            <li><strong style={{ color: '#e4e4f0' }}>Activity data:</strong> Usage data collected through our app.</li>
            <li><strong style={{ color: '#e4e4f0' }}>Content:</strong> Any content you created or uploaded.</li>
            <li><strong style={{ color: '#e4e4f0' }}>Sessions:</strong> Authentication tokens and session data.</li>
          </ul>
          <div className="dd-info-box">
            Some anonymized, aggregated data that cannot be linked back to you may be retained for analytics purposes, in accordance with our <Link to="/privacy">Privacy Policy</Link>.
          </div>
        </div>

        {/* Contact */}
        <div className="dd-section">
          <h2>Contact us</h2>
          <p>
            If you have questions about your data or this process, reach out at{' '}
            <a href="mailto:privacy@golaunchnow.io">privacy@golaunchnow.io</a>.
            We respond within 30 days.
          </p>
        </div>

        {/* Footer */}
        <div style={{ marginTop: 60, paddingTop: 24, borderTop: '1px solid rgba(255,255,255,0.06)',
                      display: 'flex', gap: 24, fontSize: 12, color: 'var(--text-dim, #666)' }}>
          <Link to="/privacy"       style={{ color: 'inherit' }}>Privacy Policy</Link>
          <Link to="/terms"         style={{ color: 'inherit' }}>Terms of Service</Link>
          <Link to="/data-deletion" style={{ color: 'inherit' }}>Data Deletion</Link>
          <a href="mailto:privacy@golaunchnow.io" style={{ color: 'inherit' }}>Contact</a>
        </div>

      </div>
    </div>
  );
}
